// extracted by mini-css-extract-plugin
export var itemStyle = "event_date-module--itemStyle--AZuTy";
export var wrapperStyle = "event_date-module--wrapperStyle--j+9Ss";